class CompanyModel {
  constructor({
    companyId = null,
    companyName,
    numOfBranches,
    vision,
    mission,
    purpose,
    companyLogo = null,
    numOfJobGroups,
    numOfSalaryGroups,
    referencedCompanyId = null,
    language,
  }) {
    this.companyId = companyId;
    this.companyName = companyName;
    this.numOfBranches = numOfBranches;
    this.vision = vision;
    this.mission = mission;
    this.purpose = purpose;
    this.companyLogo = companyLogo;
    this.numOfJobGroups = numOfJobGroups;
    this.numOfSalaryGroups = numOfSalaryGroups;
    this.referencedCompanyId = referencedCompanyId;
    this.language = language;
    // Perform validation on initialization
    this.validate();
  }

  validate() {
    if (!this.companyName || this.companyName.trim() === "") {
      throw new Error("Company Name shouldn't be empty");
    }
  }
}

export default CompanyModel;
